<template>
  <div class="widget-item" :id="widget.object.wid" :style="style">
    <WeatherView class="weather-app" :app="widget.object" />
  </div>
</template>

<script>
  import WeatherView from '@/components/apps/weather/WeatherView.vue';

  import templateWidget from '@/components/templates/mixins/templateWidget';
  import { simpleTypeMixin } from '@/helpers';

  export default {
    name: 'WeatherWidget',

    components: {
      WeatherView,
    },

    mixins: [simpleTypeMixin, templateWidget],

    props: {
      widget: {
        type: Object,
        required: true,
      },
    },

    computed: {
      style() {
        return {
          ...this.defaultStyling(this.widget),
          overflow: 'hidden',
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .widget-item {
    position: absolute;
    overflow: hidden;
  }
</style>
